import request from '../utils/request'

const prefix = '/api/v1/back'

/**
 * 院校调剂信息（查询补充列表）
 * @param {*} query
 */
export const adjustAddlist = (query) => {
    return request({
        url: `${prefix}/college/adjustAdd/list`,
        method: 'get',
        params: query
    })
}


/**
 * 院校调剂信息（查询补充详情）
 * @param {*} query
 */
export const adjustAddOne = (query) => {
    return request({
        url: `${prefix}/college/adjustAdd`,
        method: 'get',
        params: query
    })
}


/**
 * 院校补充调剂（创建补充调剂）
 * @param {*} query
 */
export const createAdjustAdd = (query) => {
    return request({
        url: `${prefix}/college/adjustAdd`,
        method: 'post',
        data: query
    })
}


/**
 * 院校补充调剂（修改）
 * @param {*} query
 */
export const editAdjustAdd = (query) => {
    return request({
        url: `${prefix}/college/adjustAdd`,
        method: 'put',
        data: query
    })
}


/**
 * 院校补充调剂（审核）
 * @param {*} query
 */
export const adjustAddcheck = (query) => {
    return request({
        url: `${prefix}/college/adjustAdd/check`,
        method: 'put',
        data: query
    })
}


/**
 * 院校补充调剂（删除补充调剂）
 * @param {*} query
 */
export const deleteAdjustAdd = (query) => {
    return request({
        url: `${prefix}/college/adjustAdd`,
        method: 'delete',
        data: query
    })
}


/**
 * 院校协助调剂（查询协助调剂列表）
 * @param {*} query
 */
export const adjustHelplist = (query) => {
    return request({
        url: `${prefix}/college/adjustHelp/list`,
        method: 'get',
        params: query
    })
}


/**
 * 院校协助调剂（根据uid批量修改联系状态）
 * @param {*} query
 */
export const adjustHelpcontact = (query) => {
    return request({
        url: `${prefix}/college/adjustHelp/contact`,
        method: 'put',
        data: query
    })
}



/**
 * 院校调剂文章（查询列表）
 * @param {*} query
 */
export const adjustArticlelist = (query) => {
    return request({
        url: `${prefix}/college/adjustArticle/list`,
        method: 'get',
        params: query
    })
}

/**
 * 院校调剂文章（创建）
 * @param {*} query
 */
export const createAdjustArticle = (query) => {
    return request({
        url: `${prefix}/college/adjustArticle`,
        method: 'post',
        data: query
    })
}


/**
 * 院校调剂文章（查询详情）
 * @param {*} query
 */
export const adjustArticleOne = (query) => {
    return request({
        url: `${prefix}/college/adjustArticle`,
        method: 'get',
        params: query
    })
}


/**
 * 院校调剂文章（修改）
 * @param {*} query
 */
export const editAdjustArticle = (query) => {
    return request({
        url: `${prefix}/college/adjustArticle`,
        method: 'put',
        data: query
    })
}


/**
 * 院校调剂文章（删除）
 * @param {*} query
 */
export const deleteAdjustArticle = (query) => {
    return request({
        url: `${prefix}/college/adjustArticle`,
        method: 'delete',
        data: query
    })
}


/**
 * 信息更新 调剂信息 列表接口 
 * @param {*} query
 */
export const adjustAdminlist = (query) => {
    return request({
        url: `${prefix}/college/adjustAdmin/list`,
        method: 'get',
        params: query
    })
}


/**
 * 调剂信息统计
 * @param {*} query
 */
export const adjustStatistics = (query) => {
    return request({
        url: `${prefix}/college/adjustAdmin/statistics`,
        method: 'get',
        params: query
    })
}


/**
 * 调剂信息（创建 单个院校批量）
 * @param {*} query
 */
export const bulksingleCollege = (query) => {
    return request({
        url: `${prefix}/college/adjustAdmin/bulk/singleCollege`,
        method: 'post',
        data: query
    })
}

/**
 * 调剂信息（查询详情）
 * @param {*} query
 */
export const adjustAdmin = (query) => {
    return request({
        url: `${prefix}/college/adjustAdmin`,
        method: 'get',
        params: query
    })
}

/**
 * 调剂信息（修改）
 * @param {*} query
 */
export const adjustAdminEdit = (query) => {
    return request({
        url: `${prefix}/college/adjustAdmin`,
        method: 'put',
        data: query
    })
}


/**
 * 调剂推荐（查询报告数据）
 * @param {*} query
 */
export const reportDatalist = (query) => {
    return request({
        url: `${prefix}/college/adjustAdmin/reportData/list`,
        method: 'get',
        params: query
    })
}

/**
 * 调剂信息 （删除）
 * @param {*} query
 */
export const deleteAdjustAdmin = (query) => {
    return request({
        url: `${prefix}/college/adjustAdmin`,
        method: 'delete',
        data: query
    })
}

export const applyInfoList = (query) => {
    return request({
        url: `${prefix}/adjust26/user/amendApply/list`,
        method: 'get',
        params: query
    })
}

export const applyInfoDate = (query) => {
    return request({
        url: `${prefix}/adjust26/user/amendApply/list`,
        method: 'delete',
        data: query
    })
}

//报考和成绩信息审核接口
export const amendApplyCheck = (query) => {
    return request({
        url: `${prefix}/adjust26/user/amendApply/check`,
        method: 'post',
        data: query
    })
}
//根据id查询审核列表详情
export const getamendApplybyId = (query) => {
    return request({
        url: `${prefix}/adjust26/user/amendApply/byId`,
        method: 'get',
        params: query
    })
}

export const getAdjustableMajorList = (query) => {
  return request({
    url: `${prefix}/adjust26/svip/adjustableMajor`,
    method: 'get',
    params: query
  })
}
export const getExtendMajorList = (query) => {
  return request({
    url: `${prefix}/adjust26/user/extendMajor`,
    method: 'get',
    params: query
  })
}

export const getSubjustList = (query) => {
  return request({
    url: `${prefix}/adjust26/svip/allSubject/byCollegeMajor`,
    method: 'get',
    params: query
  })
}
export const getProvincelist = (query) => {
  return request({
    url: `${prefix}/province/list`,
    method: 'get',
    params: query
  })
}
export const getUnlimitUserlist = (query) => {
  return request({
    url: `${prefix}/adjust26/user/unlimitUser/list`,
    method: 'get',
    params: query
  })
}
export const modifyCountUnlimit = (query) => {
    return request({
        url: `${prefix}/adjust26/user/modifyCountUnlimit/bulk`,
        method: 'post',
        data: query
    })
}
export function getMoreData(params) {
  return request({
    url: `${prefix}/adjust26/svip/reportCollegeByType/list`, 
    method: 'get',
    params: params
  })
}

export function byFileImport(query) {
  return request({
    url: `${prefix}/adjust26/info/bulk/byImport`, 
    method: 'post',
    data: query

  })
}




